import { addProductMedia } from 'backend/products';

$w.onReady(async function () {

const product =  await $w('#productPage1').getProduct();
const productId = product._id;
console.log('productId', productId)
const src = "https://www.youtube.com/watch?v=CZh-6r4IQwo";
const mediaData = [{ src }];

addProductMedia(productId, mediaData).then(res => {
	console.log(res)
}).catch(e => {console.log('err', e)})
	
});